import React from "react";

export const getFiletypeIcon = (file_type, height, width) => {
    var src;

    switch(file_type.toLowerCase()) {
        case 'jpg':
            src = "jpg";
            break;
        case 'jpeg':
            src = "jpg";
            break;
        case 'doc':
            src = "doc";
            break;
        case 'png':
            src = "png";
            break;
        case 'mp4':
            src = "mp4";
            break;
        case 'pdf':
            src = "pdf";
            break;
        default:
            src = "file";
            break;
    }

    return <img src = {require('../images/icons/filetype/'+src+'.png')} width={width} height={height} />
};



// WEBPACK FOOTER //
// ./src/utils/Icons.js